import { useState, type FormEvent } from "react";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { api, ApiError } from "../lib/api";
import { useAuth } from "../lib/auth";

export function DataDeletion() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [email, setEmail] = useState(user?.email ?? "");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    const cleanEmail = email.trim();
    if (!/^\S+@\S+\.\S+$/.test(cleanEmail)) {
      setError(t("dataDeletion.errEmail"));
      return;
    }
    setSubmitting(true);
    try {
      await api("/api/data-deletion", {
        method: "POST",
        body: { email: cleanEmail, message: message.trim() || undefined },
      });
      setDone(true);
    } catch (err) {
      setError((err as ApiError).message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="container auth">
      <div className="surface auth__card">
        <h1>{t("dataDeletion.title")}</h1>
        {done ? (
          <>
            <p role="status">{t("dataDeletion.success")}</p>
            <p className="checkemail__fallback">
              <Link to="/">{t("dataDeletion.backHome")}</Link>
            </p>
          </>
        ) : (
          <>
            <p>{t("dataDeletion.intro")}</p>
            <form onSubmit={onSubmit} noValidate>
              <div className="field">
                <label htmlFor="dd-email">{t("dataDeletion.emailLabel")}</label>
                <input
                  id="dd-email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={submitting}
                />
              </div>
              <div className="field">
                <label htmlFor="dd-message">{t("dataDeletion.messageLabel")}</label>
                <textarea
                  id="dd-message"
                  rows={3}
                  maxLength={1000}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  disabled={submitting}
                  placeholder={t("dataDeletion.messagePlaceholder")}
                />
              </div>
              {error && (
                <p className="field__error" role="alert">{error}</p>
              )}
              <button type="submit" className="btn btn-primary" disabled={submitting}>
                {submitting ? t("dataDeletion.submitting") : t("dataDeletion.submit")}
              </button>
            </form>
            <p className="field__help">{t("dataDeletion.fallback")}</p>
          </>
        )}
      </div>
    </div>
  );
}
